var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my_add_button"},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.show_dialog}},[_vm._v(_vm._s(_vm.btnText))]),_vm._v(" "),(_vm.isShow)?_c('my_add_dialog',{attrs:{"type":_vm.type,"selectIds":_vm.selectedIds,"article-type":_vm.articleType},on:{"close":_vm.close,"confirm":_vm.confirm}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa38f4aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my_add_button/index.vue
// module id = null
// module chunks = 